import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type DeleteMatchStudentSemestersMutationVariables = Types.Exact<{
  ids?: Types.Maybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
}>;


export type DeleteMatchStudentSemestersMutation = { deleteMatchStudentSemesters?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'MatchStudentSemester', id: number }>>> };


export const DeleteMatchStudentSemestersDocument = gql`
    mutation deleteMatchStudentSemesters($ids: [Int!]) {
  deleteMatchStudentSemesters(ids: $ids) {
    id
  }
}
    `;
export type DeleteMatchStudentSemestersMutationFn = ApolloReactCommon.MutationFunction<DeleteMatchStudentSemestersMutation, DeleteMatchStudentSemestersMutationVariables>;

/**
 * __useDeleteMatchStudentSemestersMutation__
 *
 * To run a mutation, you first call `useDeleteMatchStudentSemestersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchStudentSemestersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchStudentSemestersMutation, { data, loading, error }] = useDeleteMatchStudentSemestersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMatchStudentSemestersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMatchStudentSemestersMutation, DeleteMatchStudentSemestersMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteMatchStudentSemestersMutation, DeleteMatchStudentSemestersMutationVariables>(DeleteMatchStudentSemestersDocument, baseOptions);
      }
export type DeleteMatchStudentSemestersMutationHookResult = ReturnType<typeof useDeleteMatchStudentSemestersMutation>;
export type DeleteMatchStudentSemestersMutationResult = ApolloReactCommon.MutationResult<DeleteMatchStudentSemestersMutation>;
export type DeleteMatchStudentSemestersMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMatchStudentSemestersMutation, DeleteMatchStudentSemestersMutationVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
